 cafm.pb = {
    render: function (o) {

        var pbo = {
            expandMode: o.MultiSelect ? 'multiple' : 'single'
        }
        var kpb = $('#{0}'.format(o.ClientId));

        if (o.OnSelect) {

            var os;

            if (isStr(o.OnSelect)) {

                os = cafm.util.getReference(o.OnSelect);
            }
            else if (isFunc(o.OnSelect)) {

                os = o.OnSelect;
            }

            if (isFunc(os)) {

                pbo.select = function (e) {
                    var item = $(e.item);
                    kpb.data('activeKey', item.data('key'));
                    os(e);
                };
            }
        }

        if (o.DisableAnimation) {
            pbo.animation = false;
        }

        kpb = kpb.kendoPanelBar(pbo);

        // trigger the ajax action for any selected panels that require ajax requests to load content
        kpb.find('li[data-action].k-state-active .k-link').click();

        cafm.pb.displayItemCounts(kpb);
    },
    displayItemCounts: function (pbElement) {

        $('[data-count]', pbElement).each(function (i, el) {

            var pbItem = $(el);
            var count = pbItem.data('count');
            cafm.pb.displayItemCount(pbItem, count);
        });
    },
    displayItemCount: function (pbItem, count, updateData) {

        var kIn = $('.k-link:first', pbItem);
        var itemCountEl = $('.pbItemCount', kIn);

        if (!itemCountEl.length) {

            itemCountEl = $('<span/>', {

                'class': 'pbItemCount'
            }).appendTo(kIn);
        }

        if (count > 0) {

            itemCountEl.text(count);
        }
        else if (itemCountEl.length) {

            itemCountEl.remove();
        }

        if (updateData) {

            pbItem.data('count', count);
        }
    },
    updateListItemCount: function (list, itemKey, isInPanelBar) {

        if (!isStr(itemKey)) {

            itemKey = cafm.enums.getEnumKey(cafm.enums.Navigatable, itemKey);
        }

        var itemEl;

        if (isMobile || isInPanelBar) {

            itemEl = list.parents('li.k-item[data-key="{0}"]:first'.format(itemKey));
        }
        else {

            var activeFormCategorySelector = '.tvActive[data-key="{0}"]'.format(itemKey);
            itemEl = $(activeFormCategorySelector);
        }

        var count = list.data('filteredTotal');

        if (!cafm.util.isNum(count)) {
            count = list.data('unfilteredTotal');
        }

        if (!cafm.util.isNum(count)) {
            count = list.getListItemCount();
        }

        cafm.pb.displayItemCount(itemEl, count, true);
    }
}